import axios from "axios";

const API_BASE_URL =
process.env.REACT_APP_API_URL ||
(process.env.NODE_ENV === "production"
? "https://api.linemoto.co.kr"
: "http://localhost:5001");

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  // 서버가 응답을 못 보내는 상황(커넥션 대여 실패 등)에서 무한 대기하면
  // 결제 버튼이 처리 중 상태로 잠겨 그 PC로는 계산을 못 하게 된다.
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 로그인 후 저장된 토큰을 모든 요청에 자동으로 부착
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 백엔드는 사유를 error(업무 규칙 위반) 또는 message(인증 실패)로 준다. 둘 다 본다.
export const errorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.response?.data?.message || fallback;

// 토큰 수명은 12시간이라 매장이 아침에 로그인해 하루 종일 켜두면 저녁에 만료된다.
// 그대로 두면 저장·수정만 조용히 실패해 직원이 이유를 모른 채 재시도한다 → 재로그인으로 보낸다.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 로그인·비밀번호 확인의 401은 화면이 직접 안내하므로 건드리지 않는다
    const isAuthAttempt = (error.config?.url || "").startsWith("/auth/");
    if (error.response?.status === 401 && !isAuthAttempt && localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("selected_store_id");
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
